import React from 'react';
import cn from 'classnames';

import styles from './Action.module.scss';
import { useTheme } from '@repo/themes';

export default function Action({
  className = null,
  secondary = false,
  block = false,
  forceDarkMode = false,
  ...props
}) {
  const [theme] = useTheme();

  return (
    <button
      className={cn(
        'btn',
        styles.button,
        secondary && styles.secondary,
        className,
        theme === 'light' && !forceDarkMode && styles.light,
        block && 'btn-block',
      )}
      {...props}
    />
  );
}
